import { createApp } from "vue";
import HikeMap from "./HikeMap.vue"
import store from "./store/store";

if (document.querySelector('#hike-map')) {
  const app = createApp(HikeMap)
  app.use(store);
  app.mount('#hike-map');
}
